export const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '0 VNĐ';
    return `${amount.toLocaleString('vi-VN')} VNĐ`;
};

export const formatDate = (date, format = 'DD/MM/YYYY') => {
    if (!date) return '';
    const dayjs = require('dayjs');
    return dayjs(date).format(format);
};

export const formatPercent = (value, precision = 1) => {
    if (!value && value !== 0) return '0%';
    return `${value.toFixed(precision)}%`;
};

export const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return `${text.substring(0, maxLength)}...`;
};
